export default __webpack_public_path__ + "static/media/screws.ef2511b9.webp";